'use client'

import { BasicFPLStats } from '@/components/custom/fpl/basic-fpl-stats'

export function FplHomePage() {
  return <BasicFPLStats />
}
